import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const Emails = lazy(() => import('../../container/emails'));
const ReceivedEmails = lazy(() => import('../../container/emails/received'));
const ForwardTo = lazy(() => import('../../container/emails/forward'));

const EmailRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/emails`} component={Emails}/>
            <Route path={`${path}/received-emails`} component={ReceivedEmails}/>
            <Route path={`${path}/forward-to`} component={ForwardTo}/>
        </Switch>
    );
};

export default EmailRoutes;